"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    warningModalMessage: {
        marginBottom: theme.spacing(),
        color: theme.palette.grey['900']
    },
    warningModalActions: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    colorBlack: {
        color: theme.palette.grey['900']
    }
});
exports.default = styles;
//# sourceMappingURL=WarningModalStyle.js.map